import { render } from "./temperatureCurve.vue?vue&type=template&id=6316a122&scoped=true"
import script from "./temperatureCurve.vue?vue&type=script&lang=js"
export * from "./temperatureCurve.vue?vue&type=script&lang=js"

import "./temperatureCurve.vue?vue&type=style&index=0&id=6316a122&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6316a122"]])

export default __exports__